/**
 * MembershipCard.js — Goosecross membership card.
 *
 * OVERRIDES: src/components/base/MembershipCard.js
 *
 * Old createWineMembership (main.js): cover_image_link || defaultCardLogo
 * (goose-bkg.webp). When the membership response has no cover, always show
 * theme.card_logo_url / membership_card_image (or the local goose-bkg asset).
 */

import BaseMembershipCard from "../../../components/base/MembershipCard.js";
import { getTheme } from "../../../core/configAccessors.js";
import { ASSETS_BASE_URL } from "../../../core/env.js";
import { emit } from "../../../core/state.js";

// Original Goose membership Learn more icon.
const MEMBERSHIP_ICON = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2.66675 13.0002V3.00016C2.66675 2.55814 2.84234 2.13421 3.1549 1.82165C3.46746 1.50909 3.89139 1.3335 4.33341 1.3335H13.3334V14.6668H4.33341C3.89139 14.6668 3.46746 14.4912 3.1549 14.1787C2.84234 13.8661 2.66675 13.4422 2.66675 13.0002ZM2.66675 13.0002C2.66675 12.5581 2.84234 12.1342 3.1549 11.8217C3.46746 11.5091 3.89139 11.3335 4.33341 11.3335H13.3334M8.00008 6.66683C8.73646 6.66683 9.33341 6.06988 9.33341 5.3335C9.33341 4.59712 8.73646 4.00016 8.00008 4.00016C7.2637 4.00016 6.66675 4.59712 6.66675 5.3335C6.66675 6.06988 7.2637 6.66683 8.00008 6.66683ZM8.00008 6.66683C8.53051 6.66683 9.03922 6.87754 9.4143 7.25262C9.78937 7.62769 10.0001 8.1364 10.0001 8.66683M8.00008 6.66683C7.46965 6.66683 6.96094 6.87754 6.58587 7.25262C6.21079 7.62769 6.00008 8.1364 6.00008 8.66683" stroke="#6E1811" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>`;

function resolveLogoSrc() {
  const logo =
    getTheme("card_logo_url") || getTheme("membership_card_image") || null;
  if (!logo) {
    return `${ASSETS_BASE_URL}/assets/goosecross/goose-bkg.webp`;
  }
  if (/^https?:\/\//i.test(logo)) return logo;
  return `${ASSETS_BASE_URL}${logo}`;
}

export default class GooseMembershipCard extends BaseMembershipCard {
  render(club) {
    const card = super.render(club);
    const learn = card.querySelector(".ws-card-learnmore");
    if (learn) {
      const icon = learn.querySelector("svg");
      if (icon) icon.outerHTML = MEMBERSHIP_ICON;
    }
    const head = card.querySelector(".ws-card-head");
    const cover = String(club?.cover_image_link || "").trim();

    // Membership has a real cover — leave base render alone.
    if (cover && head?.querySelector("img")) return card;

    // No cover (or base left head empty) → force default Goose logo.
    if (!head) return card;

    let img = head.querySelector("img");
    if (!img) {
      img = document.createElement("img");
      img.className = "ws-card-img";
      img.alt = club.title || "Membership";
      img.loading = "lazy";
      img.style.cursor = "pointer";
      const label =
        club.message || `Tell me more about ${club.title || "this membership"}`;
      img.addEventListener("click", () =>
        emit("ws-prompt-select", {
          label,
          value: label,
          uniqueId: club.unique_id,
        }),
      );
      head.appendChild(img);
    }

    img.src = resolveLogoSrc();
    img.classList.add("ws-rich-mem-logo");
    return card;
  }
}
